import React from "react";
import LogoX from "../assets/twitter.png";
import { FaTelegram } from "react-icons/fa";

const Footer = () => {
  return (
    <div className=" px-4 md:px-16 bg-warm-yellow  border-t border-black">
      <div className="py-12 space-y-4 md:space-y-0 md:grid grid-cols-2 w-fit mx-auto  gap-8 justify-center">
        <div className="flex items-center gap-4 p-2 rounded-lg border-2 border-black cursor-pointer" >
          <a href="www.twitter.com" target="_blank" className="flex items-center gap-4">
          <img src={LogoX} alt="" className="w-8" />
          <span className="">Twitter</span>
          </a>
        </div>
        <div className="flex items-center gap-4 p-2 rounded-lg border-2 border-black cursor-pointer">
          <a href="www.telegram.com" target="_blank" className="flex items-center gap-4">

          <FaTelegram className="text-4xl" />
          <span className="">Telegram</span>
          </a>
        </div>
      </div>
      <div className="text-center text-sm md:text-xl pb-8">Copyright © 2024 ELEPHONK. All Rights Reserved</div>
    </div>
  );
};

export default Footer;
